import { api } from "./client";

export type ServerUpdateInfo = {
  /** false: not an office server, or it was installed before updates from the dashboard existed. */
  available: boolean;
  can_update?: boolean;
  installed?: { version: string; python: string; postgres: string };
  /** An uploaded update is waiting for the server PC to pick it up (within a minute). */
  waiting?: boolean;
  last?: { state: "installing" | "done" | "failed"; version: string; message: string; at: string } | null;
};

export async function getServerUpdate() {
  const { data } = await api.get<ServerUpdateInfo>("/server-update", { timeout: 8000 });
  return data;
}

export async function uploadServerUpdate(file: File, onProgress: (percent: number) => void) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post<{ version: string; waiting: boolean }>("/server-update", form, {
    // A large file over a slow office network: give it time.
    timeout: 10 * 60 * 1000,
    onUploadProgress: (e) => {
      if (e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
  return data;
}
